import {
  DELETE_PROMOCODE_START,
  DELETE_PROMOCODE_SUCCESS,
  DELETE_PROMOCODE_ERROR
} from '../../../constants';
import query from '../../../routes/site-admin/promoCode/promoCodeList/getAllPromoCode.graphql';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { deletePromoCodeMutation } from '../../../lib/graphql';

export const deletePromoCode = (id) => {
  return async (dispatch, getState, { client }) => {

    try {
      dispatch({
        type: DELETE_PROMOCODE_START,
        payload: {
          promoCodeLoading: true
        }
      });

      const { data } = await client.mutate({
        mutation: deletePromoCodeMutation,
        variables: { id },
        refetchQueries: [{
          query,
          variables: { currentPage: 1 }
        }]
      });

      if (data?.deletePromoCode?.status === 200) {
        showToaster({ messageId: 'deletePromoCodeSuccess', toasterType: 'success' });
        await dispatch({
          type: DELETE_PROMOCODE_SUCCESS,
          payload: {
            promoCodeLoading: false
          }
        });
      }
      else {
        showToaster({ messageId: 'errorMessage', requestContent: { content: data?.deletePromoCode?.errorMessage }, toasterType: 'error' });
        await dispatch({
          type: DELETE_PROMOCODE_ERROR,
          payload: {
            promoCodeLoading: false,
            error: data?.deletePromoCode?.errorMessage
          }
        });
      }
    } catch (error) {
      showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });
      await dispatch({
        type: DELETE_PROMOCODE_ERROR,
        payload: {
          promoCodeLoading: false,
          error: "Something went wrong! " + error
        }
      });
    }
  }
}